const state = {
  slides: [],
  isSlidesLoading: false,
};

export default state;
